import { PreviewType } from '../types/PreviewType';
import React, { useRef, useEffect } from 'react';
import Preview from '../Preview';
import './Carousel.scss';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import usePrevious from './usePrevious';
import { LeftArrow } from './LeftArrow';
import { RightArrow } from './RightArrow';
import { onWheel } from './onWheel';
import { Card } from './Card';

export type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;
export interface Props {
  previews: PreviewType[];
  onDeletePreview: (index: number) => void;
  extraItem?: JSX.Element;
}

const Carousel = ({ previews, onDeletePreview, extraItem }: Props) => {
  const apiRef = useRef({} as scrollVisibilityApiType);
  const items: JSX.Element[] = previews.map((preview, index) => {
    const props = {
      ...preview,
      showTooltips: true,
      onDelete: () => onDeletePreview(index),
    };
    return (
      <Card key={index} itemId={String(index)} className="item">
        <Preview {...props} />
      </Card>
    );
  });
  if (extraItem) {
    items.push(
      <Card key="attach-more" className="extra-item" itemId={String(items.length)}>
        {extraItem}
      </Card>
    );
  }

  const itemsPrev = usePrevious(items) as JSX.Element[];

  useEffect(() => {
    if (items.length > itemsPrev?.length) {
      const lastItemId = String(items.length - 1);
      const item = apiRef.current?.getItemElementById(lastItemId);
      item && apiRef.current?.scrollToItem?.(item);
    }
  }, [items, itemsPrev]);

  return (
    <div className="carousel-container">
      <div className="content">
        <ScrollMenu apiRef={apiRef} onWheel={onWheel} LeftArrow={LeftArrow} RightArrow={RightArrow}>
          {items}
        </ScrollMenu>
      </div>
    </div>
  );
};

export default Carousel;
